'use client';
import { getLinkProps } from '@/app/lib';
import { getImageBuilder } from '@/app/lib/media-helper';
import Link from 'next/link';
import { AppImage, Typography } from '@workspace/ui/common';
import type { IHeaderData } from '../interfaces';

interface HeaderLogoProps {
  headerData?: IHeaderData | null;
}

export const Logo = ({ headerData }: HeaderLogoProps) => {
  if (!headerData?.headerLogo) return null;
  const { headerLogo } = headerData;

  const linkProps = getLinkProps(headerLogo.link);

  // Ensure href is always defined for Next.js Link
  if (!linkProps.href) {
    return null;
  }

  return (
    <Link {...linkProps} className="flex items-center mr-25">
      {headerLogo.imageUrl ? (
        <div className="relative aspect-[21/5] h-6 sm:h-7.5">
          <AppImage
            src={getImageBuilder(headerLogo.imageUrl).width(126).dpr(1).url()}
            alt={headerData.title || 'Logo'}
            className="cursor-pointer"
            quality={100}
            fill
            sizes="126px"
          />
        </div>
      ) : (
        <Typography variant="h1" className="text-primary-500 font-bold text-2xl">
          porta
        </Typography>
      )}
    </Link>
  );
};
